import { render } from "./BackgroundAnimation.vue?vue&type=template&id=81581012"
import script from "./BackgroundAnimation.vue?vue&type=script&lang=js"
export * from "./BackgroundAnimation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Sites/bcfcareer25/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__